
import React from 'react';
import { serviceOptions, residentialServiceOptions, planOptions, allPlanOptions } from './utils/bookingFormOptions';
import { Checkbox } from '@/components/ui/checkbox';

interface BookingFormServiceSelectionProps {
  formData: {
    services: string[];
    plan: string;
  };
  handleServiceChange: (service: string, isChecked: boolean) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  isResidential?: boolean;
}

const BookingFormServiceSelection: React.FC<BookingFormServiceSelectionProps> = ({ 
  formData, 
  handleServiceChange,
  handleChange,
  isResidential = false
}) => {
  // Choose which options to display based on whether this is for residential use
  const displayServiceOptions = isResidential ? residentialServiceOptions : serviceOptions;
  const displayPlanOptions = isResidential ? allPlanOptions : planOptions;

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Services of Interest <span className="text-sm text-gray-500">(Select all that apply)</span>
        </label>
        <div className="space-y-3 border border-input rounded-md bg-background p-4">
          {displayServiceOptions.map((service) => (
            <div key={service} className="flex items-center space-x-2">
              <Checkbox 
                id={`service-${service}`}
                checked={formData.services.includes(service)}
                onCheckedChange={(checked) => 
                  handleServiceChange(service, checked === true)
                }
              />
              <label 
                htmlFor={`service-${service}`}
                className="text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
              >
                {service}
              </label>
            </div>
          ))}
        </div>
      </div>
      
      <div>
        <label htmlFor="plan" className="block text-sm font-medium text-gray-700 mb-2">
          Plan of Interest
        </label>
        <select
          id="plan"
          name="plan"
          value={formData.plan}
          onChange={handleChange}
          className="w-full h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <option value="">Select a Plan</option>
          {displayPlanOptions.map((plan) => (
            <option key={plan} value={plan}>{plan}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default BookingFormServiceSelection;
